
import React, { useState } from "react";
import { FormGroup, Switch } from "@blueprintjs/core";

import { ILayout } from "common/form/fields/layout/ILayoutType";
import Layout from "common/form/fields/layout/Layout";
import { BlockView } from "common/views/block/BlockView.view";
import { SeparatorView } from "common/views/separator/Separator.view";
import StringUtil from "core/util/StringUtil";
import CoreContainer from "core/components/CoreContainer";
import ListOrderWidget from "common/form/widgets/listOrder/ListOrderWidget";
import LayoutField from "common/form/fields/layout/LayoutField";
import BlockLayout from "common/form/fields/layout/layoutTypes/BlockLayout";
import FlexLayout from "common/form/fields/layout/layoutTypes/FlexLayout";
import GridLayout from "common/form/fields/layout/layoutTypes/GridLayout";
import FixedLayout from "common/form/fields/layout/layoutTypes/FixedLayout";
import { registerField } from "common/form/register"; 
import Connect from "core/decorators/Connect";
import initialState from "core/reducers/initialState";
import { IFieldProps } from "decorator-form";

export interface IPanelLayoutConfig {
	panels: string[];
	wrapper: boolean;
	seperator: boolean;
}

export interface IPanelLayoutProps {
	layoutData: ILayout<IPanelLayoutConfig>;
    panelsAvailable: string[];
}

export default class PanelLayout extends React.Component<IPanelLayoutProps> {

    private renderLayout({seperator, panels, wrapper}, index, regionUuid) {
        const { panelsAvailable } = this.props;

        // if the region panel config is not defined display all available, otherwise
        // only use panels that are added as children in the panel config form as well
        const validPanels = (!panels && panelsAvailable) || panels.filter((p) => panelsAvailable && panelsAvailable.includes(p));

        // TODO use a view from core not common. Alow override to be regisered by common, etc.
        const seperatorView = seperator && <SeparatorView key={regionUuid} viewKey={StringUtil.format("%s.separator", regionUuid)} />;

        // const Provider = FragmentProvider.forFragments(regionUuid, fragmentList);
        const elements = <CoreContainer children={validPanels} seperator={seperatorView} />

        if(wrapper) {
            // TODO use a view from core not common. Alow override to be regisered by common, etc.
            return (
                <BlockView key={regionUuid + '-' + index} viewKey={StringUtil.format("%s.wrapper", regionUuid)}>
                    {elements}
                </BlockView>
            );
        }

        return elements;
    }
    
    public render() {
        const { layoutData } = this.props;
    
        return (
            <Layout data={layoutData} renderRegion={(config, index, guid) => (
                this.renderLayout(config, index, guid)
            )} />
        )
    }
    
    public static getLayoutInput<T>(panelsField: string, enabledField?: string) {
        // find it from config instances
        
        return registerField((props) => {
            const formData = props.formContext.data;

            // dont show the field if its disabled by another field named layoutEnabled
            if(enabledField && !formData[enabledField]) {
                return null;
            }

            const panelGuids = formData[panelsField];

            if(!panelGuids || !panelGuids.length) {
                return "Add child panels to edit the layout";
            }

            return React.createElement(PanelLayoytField, {availablePanels: panelGuids, ...props});
        }, "object");
    }
}

interface PanelLayoutFieldProps extends IFieldProps<ILayout<IPanelLayoutConfig>> {
    availablePanels: string[];
    options?: Array<{ value: string, label: string }>;
    isOpen: boolean;
    setOpen: (open: boolean) => void;
}

// convert the list of panel guids into select options
const mapStateTopProps = (state: typeof initialState, ownProps: PanelLayoutFieldProps): PanelLayoutFieldProps => ({
    ...ownProps,
    options: ownProps.availablePanels.map((guid) => ({
        value: guid,
        label: state.config.panels[guid] && (state.config.panels[guid].__editName || state.config.panels[guid].editName)
    }))
});

@Connect(mapStateTopProps)
class PanelLayoytField extends React.PureComponent<PanelLayoutFieldProps> {

    public render() {
        const FragmentListWidget = ListOrderWidget.withOptions(this.props.options, true);

        // use this syntax instead of LayoutField.withOptions to prevent unmount issue
        return (
            <LayoutField {...this.props}
                renderRegionInput={(value, onChange) => {
                    return (
                        <React.Fragment>
                            <FormGroup label="Wrapper">
                                <Switch checked={value.wrapper} onChange={(e: any) => onChange({...value, wrapper: e.target.checked})} />
                            </FormGroup>
                            <FormGroup label="Separator">
                                <Switch checked={value.seperator} onChange={(e: any) => onChange({...value, seperator: e.target.checked})} />
                            </FormGroup>
                            <FormGroup label="Panels">
                                <FragmentListWidget
                                    onChange={(panels) => onChange({...value, panels})}
                                    value={value.panels}
                                />
                            </FormGroup>
                        </React.Fragment>
                    );
                }}
                useDialog={true}
                layoutTypes={[BlockLayout, FlexLayout, GridLayout, FixedLayout]}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./src/panels/container/PanelLayout.tsx